<template>
  <div class="card mt-3">
    <header class="card-header">
      <p
        v-for="info in member"
        :key="info.dani"
        class="card-header-title has-background-info-light has-text-info-dark"
      >
        Informacije o igraču
      </p>
    </header>
    <div class="card-content">
      <div class="table-container">
        <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
          <tbody>
            <tr v-for="info in member" :key="info.name">
              <td>Ime</td>
              <td>{{ info.name }}</td>
            </tr>
            <tr v-for="info in member" :key="info.tag">
              <td>Tag</td>
              <td>{{ info.tag }}</td>
            </tr>
            <tr v-for="info in member" :key="info.trophies">
              <td>Trofeji (rekord)</td>
              <td>{{ info.trophies }} ({{ info.bestTrophies }})</td>
            </tr>
            <tr v-for="info in member" :key="info.expLevel">
              <td>King Level</td>
              <td>{{ info.expLevel }}</td>
            </tr>
            <tr v-for="info in member" :key="info.arena">
              <td>Arena</td>
              <td>{{ info.arena }}</td>
            </tr>
            <tr v-for="info in member" :key="info.dani">
              <td>Account kreiran</td>
              <td v-if="info.dani > 0">
                {{ Date.now() | moment('subtract', info.dani + ' days', 'calendar') }}
              </td>
              <td v-else>Prije manje od godinu dana</td>
            </tr>
            <tr>
              <th colspan="2" class="has-text-centered">Najbolja sezona</th>
            </tr>
            <tr v-for="info in member" :key="info.bestSeasonTrophies">
              <td>Trofeja na kraju sezone</td>
              <td>{{ info.bestSeasonTrophies }}</td>
            </tr>
            <tr v-for="info in member" :key="info.bestSeasonID">
              <td>Osvojenih u sezoni</td>
              <td>{{ info.bestSeasonID }}</td>
            </tr>
            <tr>
              <th colspan="2" class="has-text-centered">Borbe</th>
            </tr>
            <tr v-for="info in member" :key="info.battleCount">
              <td>Odigrano partija</td>
              <td>{{ info.battleCount }}</td>
            </tr>
            <tr v-for="info in member" :key="info.wins">
              <td>1v1 Pobjede</td>
              <td>{{ info.wins }}</td>
            </tr>
            <tr v-for="info in member" :key="info.losses">
              <td>1v1 Porazi</td>
              <td>{{ info.losses }}</td>
            </tr>
            <tr>
              <th colspan="2" class="has-text-centered">Klan</th>
            </tr>
            <tr v-for="info in member" :key="info.role">
              <td>Status</td>
              <td>{{ info.role }}</td>
            </tr>
            <tr v-for="info in member" :key="info.totalDonations">
              <td>Doniranih kartica</td>
              <td>{{ info.totalDonations }}</td>
            </tr>
            <tr v-for="donacija in donacije" :key="donacija.id">
              <td>
                <abbr :title="'Zadnjih ' + donacija.dani.toFixed(0) + ' dana'"
                  >Donacija dnevno*</abbr
                >
              </td>
              <td>{{ donacija.dpd.toFixed(2) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import { useRouter } from '@u3u/vue-hooks';

export default {
  setup() {
    const { route } = useRouter();
    const apiHost = process.env.VUE_APP_API_HOST;
    const infoURL = '/player/info/';
    const dpdURL = '/player/dpd/';
    const { id } = route.value.params;

    const member = ref([]);
    const donacije = ref([]);

    const API_URL = apiHost;

    async function getMember() {
      const response = await fetch(API_URL + infoURL + id);
      const json = await response.json();
      member.value = json;
    }

    async function getDpd() {
      const response = await fetch(API_URL + dpdURL + id);
      const json = await response.json();
      donacije.value = json;
    }

    getMember();
    getDpd();

    return {
      member,
      donacije,
    };
  },
};
</script>

<style></style>
